import React, { useState, useEffect } from "react";

import utils from "../../utils";
import CheckboxButton from "../buttons/ButtonCheckbox";
import Checkbox from "../buttons/Checkbox";

export default function ContextMenu({
	menuRef,
	item,
	setInitialState,
	addAcceptState,
	removeAcceptState,
	editItem,
	deleteItem,
	createTransition,
}) {
	function ChangeInitial() {
		setInitialState();
	}
	function ChangeAccept() {
		if (item.accept) {
			removeAcceptState();
		} else {
			addAcceptState();
		}
	}

	return (
		<div className="context-menu" ref={menuRef}>
			<ul className="options">
				{item?.type === utils.NODE ? (
					<>
						<CheckboxButton
							handleClick={ChangeInitial}
							value={item.initial}
							icon="trending_flat"
							text="Inicial"
						/>
						<CheckboxButton
							handleClick={ChangeAccept}
							value={item.accept}
							icon="adjust"
							text="Final"
						/>
						<button
							className="button-left-icon action-button"
							onClick={createTransition}
						>
							<div className="icon">add_circle</div>
							<p className="text">Transición</p>
						</button>
					</>
				) : null}
				<button
					className="button-left-icon action-button"
					onClick={editItem}
				>
					<div className="icon">edit</div>
					<p className="text">Editar</p>
				</button>
				{item?.type === utils.CONTROL_POINT || !item?.initial ? (
					<button
						className="button-left-icon danger-button"
						onClick={deleteItem}
					>
						<div className="icon">delete</div>
						<p className="text">Eliminar</p>
					</button>
				) : null}
			</ul>
		</div>
	);
}
